import React from 'react';
import { Fieldset, Subsection } from '@fourthwall/components';
export const LivestreamFields = ({ disabled }) => {
    // const { values } = useFormikContext<FormValues>()
    if (disabled)
        return null;
    return (React.createElement(Subsection, { title: "Connect source" },
        React.createElement(Fieldset, null,
            React.createElement(Fieldset.Row, null, "Copy URL and key and paste into your streaming software. Your video feed should appear here after connecting. Learn more"))));
};
